var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}} USD";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function setCardPriceElementText($el, formattedMoney) {
  if (!$el || !$el.length) return;
  var $sr = $el.children('.sr-only').first();
  if ($sr.length) {
    $el.empty().append($sr).append(document.createTextNode(formattedMoney));
  } else {
    $el.addClass('h6');
    $el.html('<span class="money">'+formattedMoney+'</span>');
  }
}

function getProductFormVariantInput(form) {
  if (!form) return null;
  return form.elements['id'] || form.querySelector('input[name="id"]');
}

function getVariantPickerVariant(form) {
  if (!form) return null;
  var formId = form.getAttribute('id');
  var picker = formId
    ? document.querySelector('variant-picker[form-id="' + formId + '"]')
    : form.closest('.product-info')?.querySelector('variant-picker');

  if (!picker) return null;

  try {
    return JSON.parse(picker.querySelector('script[data-variant]')?.textContent || 'null');
  } catch (error) {
    return null;
  }
}

function getVariantFromForm(form) {
  if (!form) return null;

  var bisWrap = form.closest('[data-block-type="buy-buttons"]')?.querySelector('.bisn-wrap');
  var storedVariantId = bisWrap?.getAttribute('data-current-variant-id');
  var idInput = getProductFormVariantInput(form);
  var variantId = storedVariantId || (idInput && idInput.value);

  if (!variantId) return getVariantPickerVariant(form);

  var pickerVariant = getVariantPickerVariant(form);
  if (pickerVariant && String(pickerVariant.id) === String(variantId)) {
    return pickerVariant;
  }

  return {
    id: parseInt(variantId, 10),
    available: pickerVariant ? pickerVariant.available : false,
    inventory_management: pickerVariant ? pickerVariant.inventory_management : 'shopify',
    product_id: bisWrap?.getAttribute('data-product-id')
  };
}

function syncKlaviyoVariantState(form, variant) {
  if (!form || !variant || !variant.id) return;

  var idInput = getProductFormVariantInput(form);
  if (idInput) {
    idInput.disabled = false;
    idInput.value = String(variant.id);
  }

  var buyButtonsBlock = form.closest('[data-block-type="buy-buttons"]');
  var bisWrap = buyButtonsBlock?.querySelector('.bisn-wrap');
  var trigger = bisWrap?.querySelector('.klaviyo-bis-trigger');
  var productId = variant.product_id || bisWrap?.getAttribute('data-product-id');

  if (bisWrap) {
    bisWrap.setAttribute('data-current-variant-id', variant.id);
    if (productId) {
      bisWrap.setAttribute('data-product-id', productId);
    }
  }

  if (trigger) {
    trigger.setAttribute('data-variant-id', variant.id);
    if (productId) {
      trigger.setAttribute('data-product-id', productId);
    }
  }

  var formId = form.getAttribute('id');
  var picker = formId
    ? document.querySelector('variant-picker[form-id="' + formId + '"]')
    : form.closest('.product-info')?.querySelector('variant-picker');
  var variantScript = picker?.querySelector('script[data-variant]');

  if (variantScript) {
    variantScript.textContent = JSON.stringify(variant);
  }

  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
    window.ShopifyAnalytics.meta.selectedVariantId = variant.id;
  }

  var url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url.toString());
}

function updateKlaviyoBackInStock(form, variant) {
  if (!form) return;

  var buyButtonsBlock = form.closest('[data-block-type="buy-buttons"]');
  if (!buyButtonsBlock) return;

  var bisWrap = buyButtonsBlock.querySelector('.bisn-wrap');
  if (!bisWrap) return;

  var trigger = bisWrap.querySelector('.klaviyo-bis-trigger');
  var bisEnabled = bisWrap.getAttribute('data-bis-enabled') === 'true';

  if (!bisEnabled) {
    bisWrap.style.display = 'none';
    if (trigger) trigger.style.display = 'none';
    return;
  }

  if (!variant) {
    variant = getVariantFromForm(form);
  }

  if (variant && variant.id) {
    syncKlaviyoVariantState(form, variant);
  }

  var showBis = !!(variant && variant.id && variant.available === false);

  if (showBis && variant.inventory_management === null) {
    showBis = false;
  }

  if (showBis) {
    bisWrap.style.display = 'block';
    if (trigger) trigger.style.display = '';
  } else {
    bisWrap.style.display = 'none';
    if (trigger) trigger.style.display = 'none';
  }
}

function initKlaviyoBackInStock() {
  document.querySelectorAll('product-form form').forEach(function(form) {
    if (!form.querySelector('[data-block-type="buy-buttons"]') && !form.closest('[data-block-type="buy-buttons"]')) {
      return;
    }

    updateKlaviyoBackInStock(form, getVariantFromForm(form));
  });
}

function syncKlaviyoVariantBeforeOpen(trigger) {
  var buyButtonsBlock = trigger.closest('[data-block-type="buy-buttons"]');
  if (!buyButtonsBlock) return;

  var form = buyButtonsBlock.querySelector('product-form form, form');
  var bisWrap = buyButtonsBlock.querySelector('.bisn-wrap');
  if (!form || !bisWrap) return;

  var variantId = trigger.getAttribute('data-variant-id') || bisWrap.getAttribute('data-current-variant-id');
  if (!variantId) return;

  var pickerVariant = getVariantPickerVariant(form);
  var productId = trigger.getAttribute('data-product-id') || bisWrap.getAttribute('data-product-id');
  var variant;

  if (pickerVariant && String(pickerVariant.id) === String(variantId)) {
    variant = pickerVariant;
  } else {
    variant = {
      id: parseInt(variantId, 10),
      available: false,
      inventory_management: pickerVariant?.inventory_management || 'shopify',
      product_id: productId
    };
  }

  syncKlaviyoVariantState(form, variant);

  if (window.klaviyo && typeof window.klaviyo.push === 'function' && productId) {
    window.klaviyo.push(['track', 'Viewed Product', {
      ProductID: productId,
      VariantID: variant.id
    }]);
  }
}

function initKlaviyoBackInStockListeners() {
  document.addEventListener('variant:change', function(event) {
    var idInput = event.detail && event.detail.formId;
    var form = idInput && idInput.form ? idInput.form : null;
    updateKlaviyoBackInStock(form, event.detail && event.detail.variant);
  });

  document.addEventListener('product:rerender', function() {
    window.requestAnimationFrame(function() {
      initKlaviyoBackInStock();
    });
  });

  $(document).on('change', 'product-form input[name="id"]', function() {
    var form = this.form;
    var variant = getVariantPickerVariant(form) || {
      id: parseInt(this.value, 10),
      available: false
    };
    updateKlaviyoBackInStock(form, variant);
  });

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('.klaviyo-bis-trigger');
    if (!trigger) return;

    syncKlaviyoVariantBeforeOpen(trigger);
  }, true);

  $(document).on('click', '.klaviyo-bis-trigger', function(event) {
    event.preventDefault();
  });
}

initKlaviyoBackInStockListeners();

$(document).ready(function(){
  var conData;
  $(function() {
    // choose target dropdown
    var select = $('#shipping-delivery');
    select.html(select.find('option').sort(function(x, y) {
      // to change to descending order switch "<" for ">"
      return $(x).text() > $(y).text() ? 1 : -1;
    }));

    // select default item after sorting (first item)
    // $('select').get(0).selectedIndex = 0;
  });
  
  $.getJSON('https://api.ipinfodb.com/v3/ip-country/?key=2466e157b0ad4c8e039bd29eb2b9e1bd9144e012dc94fb9e199cefae4732205d&format=json', function(data) {
    conData = data;
    updateShippingCountry(conData);
    initShippingChange();
  });

  

 
  
  $(document).on('click', '.collection-custom-color-cover .HorizontalList__Item a',function(e){
    
    e.preventDefault();

    var $card = $(this).closest('.product-card');
    var $swatchCover = $card.find('.collection-custom-color-cover');

    $swatchCover.find('label').removeClass('is-active');
    $swatchCover.find('.ColorSwatch__Radio').prop('checked', false);
    $(this).find('label').addClass('is-active');
    $(this).find('.ColorSwatch__Radio').prop('checked', true);

    var url = $(this).data('url');
    var image = $(this).data('image');
    var first_image = $(this).data('first-image');
    var title = $(this).data('title');
    var price = parseInt($(this).attr('data-price'), 10);
    var handle = $(this).attr('data-handle');
    var compare_price = parseInt($(this).attr('data-compare-price'), 10) || 0;
    var pro_available = $(this).data('available');
    var moneyFormat = "${{amount}} USD";
    var badge_HTML = '<badge-list class="badge-list badge-list--vertical"><sold-out-badge class="badge badge--sold-out">Sold out</sold-out-badge><on-sale-badge discount-mode="percentage" class="badge badge--on-sale" style="">Save</on-sale-badge></badge-list>';

    $(this).closest('.product-card').find("a.product-card__media").attr('href',url);
    $(this).closest('.product-card').find("a.product-title").attr('href',url);
    $(this).closest('.product-card').find("a.product-title").text(title);
    $(this).closest('.product-card').find('.product-card__media .product-card__image--primary').attr('srcset',image);
    $(this).closest('.product-card').find('.product-card__media .product-card__image--secondary').attr('srcset',first_image);
    $(this).closest('.product-card').find('.collection-size-left ul[data-handle="'+ handle +'"]').show();
    $(this).closest('.product-card').find('.collection-size-left ul[data-handle!="'+ handle +'"]').hide();
    
    $(this).closest('.product-card').find('.product-card__figure .badge-meta[data-handle="'+ handle +'"]').show();
    $(this).closest('.product-card').find('.product-card__figure .badge-meta[data-handle!="'+ handle +'"]').hide();
    
    var $priceList = $card.find('price-list').first();
    var $salePrice = $priceList.find('sale-price').first();
    var $compareAtPrice = $priceList.find('compare-at-price').first();
    var formattedPrice = Shopify.formatMoney(price, moneyFormat);
    var isOnSale = compare_price > price;

    $card.find('compare-at-price').not($compareAtPrice).remove();

    setCardPriceElementText($salePrice, formattedPrice);

    if(!$card.find(".badge-list").length){
        $card.find(".product-card__figure").prepend(badge_HTML);
    }else{
       var badge_HTML = '<sold-out-badge class="badge badge--sold-out">Sold out</sold-out-badge>';
       $card.find(".badge-list .badge--sold-out").remove();
       $card.find(".badge-list").append(badge_HTML);
    }

    if (!isOnSale) {
      $salePrice.removeClass('text-on-sale').addClass('text-subdued');
      $card.find('on-sale-badge').hide();
      if ($compareAtPrice.length) {
        $compareAtPrice.hide();
      }
    } else {
      var savePercentage = Math.round(100 - ((price * 100) / compare_price));
      var formattedComparePrice = Shopify.formatMoney(compare_price, moneyFormat);

      $salePrice.removeClass('text-subdued').addClass('text-on-sale');
      $card.find('on-sale-badge').text('SAVE ' + savePercentage + '%').show();

      if (!$compareAtPrice.length && $priceList.length) {
        $compareAtPrice = $('<compare-at-price class="text-subdued line-through"><span class="money"></span></compare-at-price>');
        $priceList.append($compareAtPrice);
      }

      setCardPriceElementText($compareAtPrice, formattedComparePrice);
      $compareAtPrice.show();
    }
   
    $(this).closest('.product-card').removeClass("sold___out");
    if(pro_available != true){ 
      $(this).closest('.product-card').addClass("sold___out"); 
    }

    filterSingleCardBySize($card);
    
    return false;
  })

   $(".ProductItem__Info--center").each(function(){
    if($(this).find(".is-active").length > 1){
      $(this).find(".true.is-active").eq(0).trigger("click");
    }
  });

  var recentViewTimer = setInterval(function(){
    if($("#shopify-section-recently-viewed-products").length){
        $(".ProductItem__Info--center").each(function(){
          if($(this).find(".is-active").length > 1){
            $(this).find(".true.is-active").eq(0).trigger("click");
          }
        });
      clearInterval(recentViewTimer);
    }
  },1000);

  var youMayAlsoLikeTimer = setInterval(function(){
    if($(".ProductRecommendations").length){
        $(".ProductItem__Info--center").each(function(){
          if($(this).find(".is-active").length > 1){
            $(this).find(".true.is-active").eq(0).trigger("click");
          }
        });
      clearInterval(youMayAlsoLikeTimer);
    }
  },1000);

  if($(".shipping-content").length){
    var pageURL = $(".shipping-content").attr("data-page");
      $.ajax({
           url: "/pages/"+pageURL,
           type: "GET",
           dataType : "html",
           success: function (data){
               $('.shipping-content').html($('#shopify-section-shipping-delivery',data).html());
               // similar to $(data).find('#showresults')
             updateShippingCountry(conData);
             initShippingChange();
              $('#shipping-delivery').trigger("change");
           },
      });
  }


  initKlaviyoBackInStock();

  $('.ProductItem__Info .product_variants :radio').on('change',function(e) {
     e.preventDefault(); 
     var image = '';  
     var val = $(this).val();
     $('.main_dropdown .options select option[value="'+val+'"]').closest('select').val(val).trigger('change'); 
     if($(this).hasClass('ColorSwatch__Radio')){
       image = $(this).data('image-url');
       $(this).closest('.ProductItem__Wrapper').find('img.ProductItem__Image:not(.ProductItem__Image--alternate)').attr('srcset',image).attr('src',image);  
     } 
     var final_value = '' 
     $('.main_dropdown .options select option:selected').each(function(i,e) {
       if(i == 0){
         final_value = $(this).val();  
       }else{
         final_value += ' / ' + $(this).val();    
       }
     })
     
     var _this = $(this); 
     $(this).closest('.ProductItem__Info').find('.master_dropdown option').each(function() {
       var title = $(this).data('title');
       var available = $(this).data('available');
       var value = $(this).val(); 
       if(title == final_value){
         if(available){
           _this.closest('.ProductItem__Info').find('.ctm_add_to_cart_btn').prop('disabled',false);  
           _this.closest('.ProductItem__Info').find('.ctm_add_to_cart_btn span').text('Add To Cart');
         }else{
           _this.closest('.ProductItem__Info').find('.ctm_add_to_cart_btn').prop('disabled',true);   
           _this.closest('.ProductItem__Info').find('.ctm_add_to_cart_btn span').text('Sold Out');  
         }    
          _this.closest('.ProductItem__Info').find('.ctm_add_to_cart_btn').attr('data-var-id',value);
       } 
     }) 
     return false; 
  })

  $(".complete-set-variants .variant-picker__option-values input").change(function(){
    if($(this).is(":checked")){
      var parentDIV = $(this).parents("product-card");
      if($(this).hasClass("sold-out")){
        parentDIV.find('.add_to_cart .ctm_add_to_cart_btn').attr("disabled", "disabled");
        parentDIV.find('.add_to_cart .ctm_add_to_cart_btn').text("Sold out");
        parentDIV.find('.add_to_cart .ctm_add_to_cart_btn').attr("data-var-id", $(this).attr("data-vid"));
      }else{
        parentDIV.find('.add_to_cart .ctm_add_to_cart_btn').removeAttr("disabled");
        parentDIV.find('.add_to_cart .ctm_add_to_cart_btn').text("Add To Cart");
        parentDIV.find('.add_to_cart .ctm_add_to_cart_btn').attr("data-var-id", $(this).attr("data-vid"));
      }
    }
  }).trigger("change");
  if($(".complete-set-variants .variant-picker__option-values label:not(.is-disabled)").length){
    $(".complete-set-variants .variant-picker__option-values label:not(.is-disabled)").eq(0).prev("input").prop("checked", true).trigger("change");  // auto select first available size 
  }

  $('.add_to_cart .ctm_add_to_cart_btn').on('click',function(e) {
     e.preventDefault();
     var id = $(this).attr('data-var-id');
     $.ajax({
        method: "post",
        url : "/cart/add.js",
        dataType: "json",
        data:{
          id: id,
          quantity: 1  
        },
        success: function(data) {
          document.dispatchEvent(new CustomEvent("cart:refresh"));    
          $('.header__secondary-nav a[aria-controls="cart-drawer"] .sr-only').trigger("click");
        },
        error: function(err) {
           console.log(err); 
        } 
     }) 
     return false; 
  })
  
  
});

function getSizeFilterAccordion() {
  var $match = $();
  $('form.facets details.accordion').each(function() {
    var title = $.trim($(this).find('.accordion__toggle .text-with-icon, .accordion__toggle').first().text()).toLowerCase();
    if (title.indexOf('in stock size') >= 0) {
      $match = $(this);
      return false;
    }
  });
  return $match;
}

function getSelectedStockSize() {
  var $sizeFilter = getSizeFilterAccordion();
  if (!$sizeFilter.length) return null;

  var $checked = $sizeFilter.find('input:checked');
  if (!$checked.length) return null;

  var selectedSize = $.trim($checked.closest('.checkbox-control').find('label').text());
  selectedSize = selectedSize.replace(/\s*\(\d+\)\s*$/, '');

  if (!selectedSize) {
    var filterValue = $checked.val() || '';
    var parts = filterValue.split('_');
    selectedSize = parts[parts.length - 1];
  }

  return $.trim(selectedSize);
}

function isSizeSoldOutForCard($card, selectedSize) {
  var normalizedSize = selectedSize.toLowerCase();
  var shouldHide = false;

  $card.find('.collection-size-left ul:visible li').each(function() {
    if ($.trim($(this).text()).toLowerCase() === normalizedSize && $(this).hasClass('sold_out')) {
      shouldHide = true;
      return false;
    }
  });

  return shouldHide;
}

function filterSingleCardBySize($card) {
  if (!$card || !$card.length) return;

  var selectedSize = getSelectedStockSize();

  if (!selectedSize) {
    $card.show();
    return;
  }

  if (isSizeSoldOutForCard($card, selectedSize)) {
    $card.hide();
  } else {
    $card.show();
  }
}

function filterCollectionCardsBySize() {
  /* check for available size */
  var sizeFilterObj = $("form.facets details.accordion__disclosure:eq(1)"); 
  if($.trim(sizeFilterObj.find(".accordion__toggle .text-with-icon").text()) == "In Stock Size"){ 
    if(sizeFilterObj.find("input:checked").length){ 
      var selectedSize = $.trim(sizeFilterObj.find("input:checked").val()); 
      $(".collection__main product-list > product-card").each(function(){ 
        var gridObj = $(this);
        $(this).find(".collection-size-left ul:visible li").each(function(){
          if($(this).text() == selectedSize && $(this).hasClass("sold_out")){
            gridObj.hide();
          }
        });
      });
    } 
  }
}

function afterCollectionFilterLoad() {
  filterCollectionCardsBySize();
}

$(document).ready(function(){
  filterCollectionCardsBySize();
});


// for main product
  if($(".ProductForm__Variants").length){
    if($("ul.ColorSwatchList").length){
      $("ul.ColorSwatchList li").each(function(){
        if($(this).find(".is-active").hasClass("false")){
          $(this).find(".is-active").removeClass("is-active");
        }
      });
      $(".ProductForm__SelectedValue").text($("ul.ColorSwatchList .is-active").attr("data-tooltip"));
    }
  }

function initShippingChange(){
  $('#shipping-delivery').on('change', function() {
   
    var cur_value = $(this).find('option:selected').attr('data-value');
    console.log(cur_value);
    $('.country-list').hide();
    $('.country-list.country-'+cur_value).show();
  }).trigger("change");
}

function updateShippingCountry(data){
  console.log(data);
  if(data != undefined){
      var cn = data.countryName.replace(' ','-');
      var cc = data.countryCode;
      $("#shipping-delivery").val(cn).change();
      $('.country-list').hide();
      var cur_value = $('#shipping-delivery').find('option:selected').attr('data-value');
      $('.country-list.country-'+cur_value).show();
      
      if($("#shipping-delivery").val() == null){
       $("#shipping-delivery").val("United States").trigger("change") 
      }
      
      if($("shippingtable").length){
        $("shippingtable").append($("#shopify-section-shipping-delivery"));
      }
  }
}

$(document).ready(function(){
  $("variant-picker input[type=radio]").change(function(){
    if($(".limited_message").length && $(".custom-variants-dropdown").length){ 
        setTimeout(function(){
          $(".custom-variants-dropdown").val($("[name=id]").val());
          var qtyRange = $(".limited_message").attr("data-qty-range").split("-");
          var selectedVar =  $("[name=id]").val();
          var availQty = parseInt($('.custom-variants-dropdown option[value="'+ selectedVar +'"]').attr("data-qty"));
        console.log(availQty)
          
          if(availQty >= parseInt(qtyRange[1]) && availQty <= parseInt(qtyRange[0])){
            $(".limited_message").show();
          }else{
            $(".limited_message").hide(); 
          }
        },500);
    }
  }).trigger("change");
});

$(document).ready(function(){ 
  /* open desktop description tab default */
  $('.product-info__block-list div[data-block-type="description"] .accordion__toggle').trigger("click");
});

$(document).ready(function(){
  $.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results==null) {
       return null;
    }
    return decodeURI(results[1]) || 0;
}
  
  
  if($.urlParam('thumb') != null && $.urlParam('thumb') != ""){
    var thumbIndex = parseInt($.urlParam('thumb')) - 1;
    $("product-gallery product-gallery-navigation button:eq("+ thumbIndex +")").trigger("click");
  }

  /*
  // if product size XS, S or M is outofstock then redirect on given URL
  if($.urlParam('outofstock') != null && $.urlParam('outofstock') != ""){
    var collHandle = $.urlParam('outofstock');
    if($("fieldset.variant-picker__option").length){
      $("fieldset.variant-picker__option").each(function(){
        var sizeLabel = $(this).find("legend").text().toLowerCase().replace(":", "");
        if(sizeLabel == "size"){
          $("fieldset.variant-picker__option .variant-picker__option-values label").each(function(){
            var optionVal = $(this).text();
            if($(this).hasClass("is-disabled")){
              if(optionVal == "XS" || optionVal == "S" || optionVal == "M"){
                window.location.href = "/collections/"+collHandle;
              }
            }
          });
        }
      });
    }
  }
  // if product size XS, S or M is outofstock then redirect on given URL
  */
  
});

$(document).ready(function(){
  if($(".showcase-gallery-block").length){
    $(".showcase-gallery-block").append('<div class="insta-shop-btn"><a href="/pages/instagram-shop" class="button w-full" >Shop Our Instagram</a></div>');
  }
});



// Find maching product based on product URL tag and append on top
// https://aquatropicswim.com/collections/all?product-top=ABC

$(document).ready(function(){
    const container = document.querySelector(".collection__main product-list");
    const cards = Array.from(container.querySelectorAll(".collection__main product-card"));

    // --- Cookie Helpers ---
    function setCookie(name, value, days = 1) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
      const nameEQ = name + "=";
      const cookies = document.cookie.split(";");
      for (let c of cookies) {
        while (c.charAt(0) === " ") c = c.substring(1);
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length);
        }
      }
      return null;
    }

    // --- Get value from URL or Cookie ---
    const params = new URLSearchParams(window.location.search);
    let filterValue = params.get("product-top");

    if (filterValue) {
      // Save to cookie
      setCookie("product-top", filterValue);
    } else {
      // Read from cookie
      filterValue = getCookie("product-top");
    }

    // --- Apply logic only if value exists ---
    if (filterValue) {
      const matched = [];
      const others = [];

      function getMatchingTag(tagString) {
        if (!tagString) return null;
        const tags = tagString.split(",").map(t => t.trim());
        return tags.find(t => t.startsWith(`top:${filterValue}:`)) || null;
      }

      function getSortNumber(tag) {
        return parseInt(tag.split(":")[2]) || 0;
      }

      cards.forEach(card => {
        const tagString = card.dataset.tag || "";
        const matchedTag = getMatchingTag(tagString);

        if (matchedTag) {
          matched.push({
            el: card,
            sort: getSortNumber(matchedTag)
          });
        } else {
          others.push(card);
        }
      });

      matched.sort((a, b) => a.sort - b.sort);

      [...matched.map(item => item.el), ...others].forEach(card => {
        container.appendChild(card);
      });
    }

   /*
    document.querySelectorAll('.collection__main product-list product-card')
    .forEach(el => {
      el.style.visibility = 'visible';
    });
    */
});

// Find maching product based on product URL tag and append on top


/* Product page instra feed */
/* check if insta feed load  from app then hide the default feed from custom block */
document.addEventListener('DOMContentLoaded', function() {
    
  if($(".shopify-section--main-product").length){
    
    const checkInstagramFeeds = () => {
      const appInstaGalleryDiv = document.querySelector('[data-gallery-id="20557"]');
      const customInstaGalleryDiv = document.querySelector('[data-gallery-id="11008"]');

      const appSection = appInstaGalleryDiv?.closest('section');
      const customSection = customInstaGalleryDiv?.closest('section');

      // Hide both initially
      if (appSection) appSection.style.display = 'none';
      if (customSection) customSection.style.display = 'none';

        const appHasItems = appSection?.querySelector('.showcase-grid-item');
        const customHasItems = customSection?.querySelector('.showcase-grid-item');

        // Priority: App feed
        if (appHasItems) {
            if (appSection) appSection.style.display = '';
            if (customSection) customSection.style.display = 'none';

            window.dispatchEvent(new Event('resize'));
            // clearInterval(feedChecker); // Stop checking once found
            return;
        }

        // Fallback: Custom feed
        if (customHasItems) {
            if (customSection) customSection.style.display = '';
            if (appSection) appSection.style.display = 'none';

            window.dispatchEvent(new Event('resize'));
            // clearInterval(feedChecker); // Stop checking once found
            return;
        }
    };

    // Check every second
    const feedChecker = setInterval(checkInstagramFeeds, 1000);

    // Initial check
    checkInstagramFeeds();
  }
});
/* Product page instra feed */        